import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Map, Layers, Tags, FileText, User, ShoppingBag } from 'lucide-react';
import PageShell from '../components/PageShell';
import { categoriesAPI, brandsAPI, pagesAPI, api } from '../services/api';
import { useT } from '../services/i18n';
import { catName, pageTitle } from '../services/catalogI18n';

const STATIC = [
  ['shop', ShoppingBag, [['/', 'sm.home'], ['/pieces', 'sm.allParts'], ['/marques', 'sm.brandsAZ'], ['/articles', 'sm.guides'], ['/comparaison', 'sm.compare'], ['/panier', 'sm.cart']]],
  ['account', User, [['/mon-compte', 'sm.myOto'], ['/mon-compte/garage', 'sm.garage'], ['/mon-compte/pro', 'sm.pro'], ['/mes-commandes', 'sm.orders'], ['/liste-de-souhaits', 'sm.wishlist'], ['/mon-compte/adresses', 'sm.addresses'], ['/mon-compte/banque', 'sm.bank'], ['/mon-compte/depot', 'sm.wallet'], ['/mon-compte/parametres', 'sm.settings'], ['/connexion', 'sm.login'], ['/inscription', 'sm.register']]],
  ['help', FileText, [['/contact', 'sm.contact'], ['/livraison', 'sm.shipping'], ['/garantie-retours', 'sm.returns'], ['/qui-sommes-nous', 'sm.about'], ['/plan-du-site', 'sm.sitemap']]],
];

const Block = ({ title, icon: Icon, links, testId }) => (
  <section className="bg-white rounded-xl shadow-sm p-5" data-testid={testId}>
    <h2 className="font-bold text-gray-900 flex items-center gap-2 mb-3"><Icon size={18} className="text-orange-500" /> {title} <span className="text-xs font-normal text-gray-400">({links.length})</span></h2>
    <ul className="columns-2 sm:columns-3 gap-4 text-sm">
      {links.map(([to, label]) => <li key={to} className="mb-1.5 break-inside-avoid"><Link to={to} className="text-gray-700 hover:text-orange-600 hover:underline">{label}</Link></li>)}
    </ul>
  </section>
);

const SitemapPage = () => {
  const { t, lang } = useT();
  const [cats, setCats] = useState([]);
  const [brands, setBrands] = useState([]);
  const [makers, setMakers] = useState([]);
  const [pages, setPages] = useState([]);
  useEffect(() => {
    categoriesAPI.getAll().then(setCats).catch(() => {});
    api.get('/vehicles/brands').then(r => setBrands(r.data.brands || [])).catch(() => {});
    brandsAPI.getAll().then(list => setMakers(list.filter(b => b.product_count > 0))).catch(() => {});
    pagesAPI.list().then(d => setPages(d.pages || d)).catch(() => {});
  }, []);
  return (
    <PageShell title={t('sm.title')} description={t('sm.description')} path="/plan-du-site" eyebrow={t('sm.eyebrow')} heading={t('sm.title')} intro={t('sm.intro')} testId="sitemap-page" wide>
      <div className="space-y-5 -mt-10 relative">
        {STATIC.map(([key, icon, links]) => <Block key={key} title={t(`sm.${key}`)} icon={icon} links={links.map(([to, k]) => [to, t(k)])} testId={`sitemap-${key}`} />)}
        <Block title={t('sm.categories')} icon={Layers} links={cats.map(c => [`/pieces/${c.slug}`, catName(c, lang)])} testId="sitemap-categories" />
        <Block title={t('sm.vehicleBrands')} icon={Tags} links={brands.map(b => [`/recherche?q=${encodeURIComponent(b)}`, b])} testId="sitemap-brands" />
        <Block title={t('sm.makers')} icon={Tags} links={makers.map(b => [`/marque/${encodeURIComponent(b.name)}`, b.name])} testId="sitemap-makers" />
        <Block title={t('sm.pages')} icon={Map} links={pages.map(p => [`/page/${p.slug}`, pageTitle(p, lang)])} testId="sitemap-pages" />
      </div>
    </PageShell>
  );
};

export default SitemapPage;
